import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation updateSlaContent($id: String!, $data: updateSlaContentInput!) {
    updateSlaContent(id: $id, data: $data) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const updateSlaContentRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;data: TYPES.UpdateSlaContentInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'sla_content/update_sla_content',
  async (
  params: {id: String;data: TYPES.UpdateSlaContentInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.updateSlaContent;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const updateSlaContentSlice = createSlice({
  name: 'update_sla_content',
  initialState: initialState,
  reducers: {
    updateSlaContentClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(updateSlaContentRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(updateSlaContentRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(updateSlaContentRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { updateSlaContentClear } = updateSlaContentSlice.actions;

export const updateSlaContent = createSelector(
  (state: RootState) => state.slaContent.updateSlaContent.result,
  (state: RootState) => state.slaContent.updateSlaContent.error,
  (state: RootState) => state.slaContent.updateSlaContent.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default updateSlaContentSlice.reducer;